export default "assets/nux_black_white_stripe.png"